export class StatiDirette {
    categoria: number = null;
    css_class: string = null;
    descrizione: string = null;
    fase_in_corso: string = null;
    events_allowed: number = null;
    min_time: number = null;
    max_time: number = null;
    id: number = null;
}

export enum STATI {
    NON_INIZIATO = 1,
    FISCHIO_DI_INIZIO = 2,
    FINE_PRIMO_TEMPO = 3,
    INIZIO_SECONDO_TEMPO = 4,
    FINE_TEMPI_REGOLAMENTARI = 5,
    INIZIO_PRIMO_SUPPLEMENTARE = 6,
    FINE_PRIMO_SUPPLEMENTARE = 7,
    INIZIO_SECONDO_SUPPLEMENTARE = 8,
    FINE_SECONDO_SUPPLEMENTARE = 9,
    RIGORI = 10,
    FINE_PARTITA = 11
}




// WEBPACK FOOTER //
// ./src/app/shared/models/stati-dirette.ts